export default "__VITE_ASSET__44f0227c__"